<plyr
  style="display: block; width: 100%"
  [plyrTitle]="videoTitle"
  plyrType="video"
  [plyrPlaysInline]="true"
  [plyrSources]="videoSources"
  (plyrInit)="player = $event"
  [plyrOptions]="options"
></plyr>
